import React from 'react';
import styles from './PicklistInfo.module.scss';

import GeneralDetails from './General';
import AssetsCounting from './Counting/AssetsCounting';

export const PicklistInfo = () => {
  return (
    <div className={styles.details}>
      <GeneralDetails />
      <AssetsCounting />
    </div>
  );
};
